<template>
  <div>
    <page-head :title="title" :show-back="true"></page-head>
    <div class="table-tabs">
      <form-info :title="'人员信息'" class="mb-1">
        <div slot="btn">
          <Button class="bkcc-btn btn" @click="addPerson">添加人员</Button>
        </div>
        <div slot="content">
          <div class="member-list" v-if="committeeList.length">
            <div
              class="admin-person member-person"
              v-for="(item,index) in committeeList"
              :key="item.id"
            >
              <div
                class="person-avatar-wrapper"
                @mouseenter="selectCommitteeIndex = index"
                @mouseleave="selectCommitteeIndex = 99"
              >
                <img v-if="item.headPicUrl" class="person-avatar" :src="item.headPicUrl" />
                <img v-else class="person-avatar" src="../../../assets/images/default.png" />
                <div
                  v-if="selectCommitteeIndex == index"
                  class="person-avatar-icons"
                  style="justify-content: center"
                >
                  <div class="iconfont icon-delete" @click="delCommittee(item.id)"></div>
                </div>
                <div class="proTitle">{{item.proTitle}}</div>
              </div>
              <div class="person-name">{{item.userName}}</div>
            </div>
          </div>
        </div>
      </form-info>

      <form-info :title="'公告'" class="mb-1">
        <div slot="btn">
          <Button class="bkcc-btn btn" @click="newNotice">新建公告</Button>
        </div>
        <div slot="content">
          <div class="table-data">
            <i-table
              :columns="tableHeader"
              :border="true"
              :loading="isTableLoading"
              :data="tableData"
              stripe
              ref="table"
            >
              <template slot-scope="{ row, index }" slot="action">
                <span @click="handleClickDetail(row,'edit')" class="action">[编辑]</span>
                <span @click="handleClickDetail(row,'del')" class="action">[删除]</span>
              </template>
            </i-table>
            <div class="page">
              <page :total="total" :current="pageNum" @on-change="pageChange" show-total />
            </div>
          </div>
        </div>
      </form-info>
      <Modal v-model="delBtn" title="删除公告" width="660px">
        <div>
          您确定要删除标题为
          <span class="red">{{noticeTitle}}</span> 的公告么？
        </div>
        <div slot="footer">
          <Button style="margin-right:10px" @click="delBtn = false">取消</Button>
          <Button type="primary" @click="onDelete">确定</Button>
        </div>
      </Modal>
      <add-member
        :showModal="addBtn"
        :zoneId="$route.query.zoneId"
        @quxiao="quxiao"
        @addMember="addMember"
      ></add-member>
    </div>
  </div>
</template>

<script>
import pageHead from "../../../components/head";
import formInfo from "../../userManager/components/formInfo";
import addMember from "./addMember";
export default {
  components: { pageHead, formInfo, addMember },
  name: "ownCommitee",
  mounted() {},
  created() {
    this.getOwnerCommitteeList();
    this.getOwnCommiteeList();
  },
  data() {
    return {
      title: this.$route.query.zoneName + "业主委员会",
      tableHeader: [
        {
          title: "标题",
          key: "title",
        },
        {
          title: "时间",
          key: "noticeTime",
        },
        {
          title: "查看数",
          key: "previewNumber",
        },
        {
          title: "操作",
          slot: "action",
        },
      ],
      tableData: [],
      committeeList: [],
      selectCommitteeIndex: 99,
      isTableLoading: false,
      pageNum: 1,
      pageSize: 10,
      total: 0,
      delBtn: false,
      addBtn: false,
      ownCommiteeUser: {},
      noticeTitle: "",
      delNoticeId: "",
    };
  },
  computed: {},
  watch: {},
  methods: {
    addPerson() {
      this.addBtn = true;
      this.ownCommiteeUser = {};
    },
    quxiao() {
      this.addBtn = false;
    },
    addMember(person) {
      this.addBtn = false;
      console.log(person);
      this.getOwnCommiteeList();
    },
    newNotice() {
      this.$router.push({
        name: "ownCommitteeDetail",
        query: { zoneId: this.$route.query.zoneId },
      });
    },
    getOwnerCommitteeList() {
      let { zoneId } = this.$route.query || sessionStorage.zoneId;
      let url = this.urlobj.ownerCommitteeList(zoneId);
      this.$get(url, {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        if (res.isSucceed) {
          this.tableData = res.rows;
          this.total = res.total;
          console.log(this.tableData);
        }
      });
    },
    // 获取业主委员会人员列表
    getOwnCommiteeList() {
      let url = this.urlobj.getOwnCommiteeList;
      this.$post(url, {
        pageNum: 1,
        pageSize: 30,
        zoneId: this.$route.query.zoneId,
      }).then((res) => {
        if (res.isSucceed) {
          this.committeeList = res.rows;
          console.log(this.committeeList);
        }
      });
    },
    handleClickDetail(item, type) {
      if (type == "edit") {
        console.log(item);
        this.$router.push({
          name: "ownCommitteeDetail",
          query: { zoneId: this.$route.query.zoneId, id: item.id },
        });
      } else if (type == "del") {
        this.delBtn = true;
        console.log(item);
        this.noticeTitle = item.title;
        this.delNoticeId = item.id;
      }
    },
    delCommittee(id) {
      console.log("del", id);
      var url = this.urlobj.delOwnCommittee(id);
      this.$delete(url).then((res) => {
        if (res.isSucceed) {
          this.$Message.success("删除成功");
          this.getOwnCommiteeList();
        }
      });
    },
    onDelete() {
      var url = this.urlobj.deleteOwnCommitteeNOtice(this.$route.query.zoneId);
      this.$delete(url, { idList: this.delNoticeId })
        .then((res) => {
          console.log(res);
          this.delBtn = false;
          if (res.isSucceed) {
            this.$Message.success("删除成功");
            this.getOwnerCommitteeList();
          }
        })
        .catch((e) => {
          this.delBtn = false;
          this.$Message.error("删除失败");
        });
    },
    pageChange(val) {
      this.pageNum = val;
      this.getOwnerCommitteeList();
    },
  },
};
</script>
<style lang="less" scoped>
.mb-1 {
  margin-bottom: 10px;
}
.red {
  color: #d22c2c;
}
.table-tabs {
  max-width: 100%;
  padding-left: 24px;
  .table-data {
    width: 100%;
    background-color: white;
    border-radius: 5px;
    padding: 20px;
    min-height: calc(100vh - 450px);
    .page {
      width: 100%;
      margin-top: 10px;
      display: flex;
      justify-content: center;
    }
    .action {
      color: #5e6d94;
      cursor: pointer;
      margin-right: 10px;
    }
  }
}
.member-list {
  display: flex;
  flex-wrap: wrap;
  // justify-content: center;
  align-items: center;
}
// 委员 单元
.member-person {
  position: relative;
  margin: 20px;
  &:hover .del-img {
    display: block;
  }
}
.admin-person {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.person-avatar-wrapper {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  position: relative;
}
.proTitle {
  position: absolute;
  bottom: -5px;
  right: 15px;
  text-align: center;
  color: #fff;
  width: 60px;
  height: 20px;
  background: #ff7744;
  border-radius: 9px;
  font-weight: bold;
}
.person-avatar-icons {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  position: absolute;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 5px;
}
.person-avatar-icons .iconfont {
  font-size: 45px;
}
.person-avatar {
  width: 90px;
  height: 90px;
  border-radius: 100%;
  box-shadow: 2px 2px 4px 1px #898989;
}
.person-name {
  font-size: 18px;
  color: #4b4b4b;
  margin-top: 10px;
}
</style>